export default {
  apiKey: 'AIzaSyDsB4Vv_398gKrQt2O675jZmzaTjgmZAgk',
  authDomain: 'app-d8a1c.firebaseapp.com',
  databaseURL: 'https://app-d8a1c.firebaseio.com',
  projectId: 'app-d8a1c',
  storageBucket: 'app-d8a1c.appspot.com',
  messagingSenderId: '375837325311',
  appId: '1:375837325311:web:7258d706e388afee9d59ca',
  measurementId: 'G-MKGTJFZ8N1',
};
